<template>
  <a :href="props.href" @click="leaveWithConfirmation(props.href, $event)"
    ><slot></slot
  ></a>
</template>

<script lang="ts" setup>
import { leaveWithConfirmation } from "./store";

const props = defineProps<{
  href: string;
}>();
</script>
